













































































import {
  defineComponent,
  PropType,
  computed,
  ref,
  onMounted,
} from "@nuxtjs/composition-api";
import { ProductParent } from "~/composables";
import { getConfigurableOptionsByProduct } from "~/modules/catalog/product/helpers";
import {
  getBgColorByVariants,
  getFirstImageByVariants,
  setSizeProductList,
} from "~/modules/catalog/category/helpers";
import FreeGiftDetailModal from "~/modules/checkout/components/cartSidebar/freeGift/FreeGiftDetailModal.vue";

export default defineComponent({
  name: "FreeGiftCart",
  components: { FreeGiftDetailModal },
  props: {
    product: {
      type: Object as PropType<ProductParent>,
      default: null,
    },
    needMoney: {
      type: Number,
      default: 0,
    },
    needQty: {
      type: Number,
      default: 0,
    },
    ampromoRuleId: {
      type: String as PropType<string | number>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const isDetailModalOpen = ref(false);
    const selectedOption = ref({
      color: null,
      size: null,
    });

    const toggleDetailModal = () => {
      isDetailModalOpen.value = true;
    };

    const variants = computed(() => {
      return props.product?.configurable_children ?? [];
    });

    const configurableOptions = computed(() => {
      const configurableOpt = props.product?.configurable_options_map ?? [];

      if (props.product.first_child_product) {
        const skuColor =
          props.product.first_child_product?.split("-")?.[1] || "";
        const skuSize =
          props.product.first_child_product?.split("-")?.[2] || "";

        return configurableOpt.map((option) => {
          if (option.attribute_code === "color" && skuColor) {
            const optionCopy = { ...option };

            optionCopy.values = [...option.values].sort((a, b) => {
              if (a.label === skuColor) return -1;
              if (b.label === skuColor) return 1;
              return 0;
            });

            return optionCopy;
          }

          if (option.attribute_code === "size" && skuSize) {
            const optionCopy = { ...option };
            optionCopy.values = [...option.values].sort((a, b) => {
              if (a.label === skuSize) return -1;
              if (b.label === skuSize) return 1;
              return 0;
            });

            return optionCopy;
          }

          return option;
        });
      }

      return configurableOpt;
    });

    const availableOptions = computed(() => {
      const availableOpt = getConfigurableOptionsByProduct(
        configurableOptions.value
      );

      if (availableOpt.color && availableOpt.color.length > 0) {
        const colorIds = variants.value.map((attr) => attr?.color?.toString());
        availableOpt.color = availableOpt.color.filter((item) =>
          colorIds.includes(item?.value_index?.toString())
        );
      }
      if (availableOpt.size && availableOpt.size.length > 0) {
        const sizeIds = variants.value.map((attr) => attr?.size?.toString());
        availableOpt.size = availableOpt.size.filter((item) =>
          sizeIds.includes(item?.value_index?.toString())
        );
      }

      return availableOpt;
    });

    const getFirstImageBySelectedOptions = computed(() => {
      if (selectedOption.value.color) {
        return getFirstImageByVariants(
          selectedOption.value.color,
          variants.value
        );
      }

      // Trả về ảnh mặc định nếu không tìm thấy
      return props.product &&
        props.product.media_gallery &&
        props.product.media_gallery.length > 0
        ? setSizeProductList(props.product.media_gallery?.[0].image)
        : setSizeProductList(props.product?.thumbnail_url);
    });

    onMounted(async () => {
      const option = availableOptions.value?.color?.[0];
      selectedOption.value[option?.type] = option;
    });

    const isOptionSelected = (attributeOption) => {
      return (
        selectedOption.value[attributeOption.type] &&
        selectedOption.value[attributeOption.type].uid === attributeOption.uid
      );
    };

    const handleChangeOption = (option) => {
      selectedOption.value[option.type] = option;
    };

    const closeSuscessModal = () => {
      isDetailModalOpen.value = false;
      emit("close");
    };

    const showMoreColor = ref(false);

    return {
      closeSuscessModal,
      getFirstImageBySelectedOptions,
      availableOptions,
      getBgColorByVariants,
      isOptionSelected,
      handleChangeOption,
      isDetailModalOpen,
      toggleDetailModal,
      showMoreColor,
      selectedOption,
      variants,
    };
  },
});
